<main>
    <div class="logo">
        <div class="img">
            <svg *ngIf="!this.appService.modoMobileEstaAtivado" xmlns="http://www.w3.org/2000/svg" width="78"
                height="45" viewBox="0 0 78 45" fill="none" data-ember-extension="1">
                <path id="letra-o" fill-rule="evenodd" clip-rule="evenodd"
                    d="M60.7672 0L60.8771 0.000239918L60.9221 0.000199816V0.000476947C74.9874 0.0872809 78.1662 12.0011 77.9936 17.9689C77.9936 29.6843 66.7131 40.5684 60.9221 44.6648V44.7738L60.8445 44.7195L60.7672 44.7736V44.665C54.9762 40.5686 43.6958 29.6845 43.6958 17.9691C43.5231 12.0013 46.7019 0.0874807 60.7672 0.000676763V0ZM60.9217 22.4238C64.0383 22.4238 66.5648 19.8973 66.5648 16.7807C66.5648 13.6641 64.0383 11.1376 60.9217 11.1376C57.8051 11.1376 55.2786 13.6641 55.2786 16.7807C55.2786 19.8973 57.8051 22.4238 60.9217 22.4238Z"
                    fill="#f2ab46" />
                <path id="letra-g"
                    d="M20.4584 43.3236C17.7306 43.3236 15.1214 42.8503 12.6308 41.9038C10.1798 40.9178 8.00546 39.4979 6.10787 37.6442C4.21028 35.751 2.70802 33.4832 1.60109 30.8407C0.533697 28.1587 0 25.1021 0 21.6707C0 18.7127 0.553464 15.9716 1.66039 13.4474C2.76732 10.9232 4.28934 8.71451 6.22647 6.82135C8.20312 4.88877 10.496 3.39002 13.1052 2.32513C15.7144 1.26023 18.541 0.727783 21.5851 0.727783C25.3803 0.727783 28.8196 1.55604 31.9032 3.21254C34.9868 4.82961 37.2797 7.058 38.782 9.89773L30.1835 16.4646C29.3533 14.8081 28.108 13.4868 26.4477 12.5008C24.7873 11.4753 23.028 10.9626 21.17 10.9626C19.3515 10.9626 17.7306 11.4359 16.3074 12.3825C14.8842 13.3291 13.7575 14.6503 12.9273 16.3463C12.1367 18.0028 11.7413 19.9156 11.7413 22.0849C11.7413 25.3584 12.6308 28.0207 14.4098 30.0716C16.2283 32.0831 18.5806 33.0888 21.4665 33.0888C24.7477 33.0888 27.7127 31.7084 30.3614 28.9475H23.0676V20.665H40.3831V43.0278H30.8358V39.5373C27.8313 42.0615 24.3722 43.3236 20.4584 43.3236Z"
                    fill="#555" />
            </svg>

            <div class="button-open-menu" (click)="this.appService.toggleSideBar()">
                <mat-icon *ngIf="this.appService.modoMobileEstaAtivado">menu</mat-icon>
            </div>
        </div>
        <h2>{{nomeLoja}}</h2>
    </div>

    <div class="right-menu">

        <ng-container *ngIf="!this.appService.modoMobileEstaAtivado">

            <div class="status-loja noselect">
                <div [matMenuTriggerFor]="statusLoja">
                    <span>Loja Aberta</span>
                    <div class="status" [class.status-aberto]="appService?.statusAbertura === 1"
                        [class.status-fechado]="appService?.statusAbertura === 0"></div>
                </div>

                <mat-menu #statusLoja="matMenu" xPosition="before">
                    <button *ngIf="appService.statusAbertura == 0" mat-menu-item (click)="appService.abrirLoja()">Abrir
                        Loja</button>
                    <button *ngIf="appService.statusAbertura == 1" mat-menu-item
                        (click)="appService.fecharLoja()">Fechar
                        Loja</button>
                </mat-menu>
            </div>

            <div class="tempo-entrega noselect" *ngIf="appService.tempoEntrega">
                <div [matMenuTriggerFor]="tempoEntrega" #tempoEntregaTrigger="matMenuTrigger"
                    title="Alterar Tempo de Entrega">
                    <span>{{appService.tempoEntrega}}m</span>
                    <mat-icon fontSet="material-icons-outlined">timer</mat-icon>
                </div>

                <mat-menu #tempoEntrega="matMenu" xPosition="before">
                    <div id="menu-tempo-entrega" mat-filter-item>
                        <p class="mg-0">Tempo de Entrega</p>
                        <input (keydown.enter)="alterarTempoEntrega()" type="number" mat-filter-item
                            [(ngModel)]="appService.inputTempoEntrega">
                        <button mat-button mat-flat-button color="primary"
                            (click)="alterarTempoEntrega()">Salvar</button>
                    </div>
                </mat-menu>
            </div>

            <div class="som noselect">
                <mat-icon (click)="appService.somMutado = !appService.somMutado"
                    title="Tocar/Mutar som de notificação">{{
                    appService.somMutado ? 'volume_off' : 'volume_up' }}</mat-icon>
            </div>

            <div class="tema noselect">
                <mat-icon [class.rotate-720]="appService.tema === 'light'" (click)="trocarTema()"
                    title="Alterar Tema">{{
                    appService.tema === 'dark' ? 'brightness_4' : 'brightness_7' }}</mat-icon>
            </div>

            <div class="perfil noselect" id="menu-tempo-entrega">
                <div [matMenuTriggerFor]="perfil">{{nomeUsuario}} <mat-icon>expand_more</mat-icon></div>
                <mat-menu #perfil="matMenu" xPosition="before">
                    <button mat-menu-item (click)="abrirModalAlterarSenha()">Alterar Senha</button>
                    <button mat-menu-item (click)="authService.logOff()">Sair</button>
                </mat-menu>
            </div>

        </ng-container>

        <ng-container *ngIf="this.appService.modoMobileEstaAtivado">

            <div #backDropBottomSheet id="botton-sheet-configuracao" class="backdrop"
                [class.visible]="this.appService.bottomSheetConfiguracaoEstaVisivel"
                (click)="this.appService.fecharBottomSheetConfiguracao()">



                <div class="content" (click)="this.appService.stopPropagation($event)">

                    <div class="botoes-config">
                        <div class="container">
                            <div class="status-loja noselect item" [matMenuTriggerFor]="statusLoja">
                                <div>
                                    <span>Loja Aberta</span>
                                    <div class="status" [class.status-aberto]="appService?.statusAbertura === 1"
                                        [class.status-fechado]="appService?.statusAbertura === 0"></div>
                                </div>

                                <mat-menu #statusLoja="matMenu" xPosition="before">
                                    <button *ngIf="appService.statusAbertura == 0" mat-menu-item
                                        (click)="appService.abrirLoja()">Abrir
                                        Loja</button>
                                    <button *ngIf="appService.statusAbertura == 1" mat-menu-item
                                        (click)="appService.fecharLoja()">Fechar
                                        Loja</button>
                                </mat-menu>
                            </div>

                            <div class="tempo-entrega m-0 noselect item" *ngIf="appService.tempoEntrega"
                                [matMenuTriggerFor]="tempoEntrega" #tempoEntregaTrigger="matMenuTrigger">
                                <div title="Alterar Tempo de Entrega">
                                    <span>{{appService.tempoEntrega}}m</span>
                                    <mat-icon fontSet="material-icons-outlined">timer</mat-icon>
                                </div>

                                <mat-menu #tempoEntrega="matMenu" xPosition="before">
                                    <div id="menu-tempo-entrega" mat-filter-item>
                                        <p class="mg-0">Tempo de Entrega</p>
                                        <input (keydown.enter)="alterarTempoEntrega()" type="number" mat-filter-item
                                            [(ngModel)]="appService.inputTempoEntrega">
                                        <button mat-button mat-flat-button color="primary"
                                            (click)="alterarTempoEntrega()">Salvar</button>
                                    </div>
                                </mat-menu>
                            </div>
                        </div>

                        <div class="container">
                            <div class="som noselect item" title="Tocar/Mutar som de notificação"
                                (click)="appService.somMutado = !appService.somMutado">
                                <mat-icon>{{
                                    appService.somMutado ? 'volume_off' : 'volume_up' }}</mat-icon>
                            </div>

                            <div class="tema m-0 noselect item" (click)="trocarTema()" title="Alterar Tema">
                                <mat-icon [class.rotate-720]="appService.tema === 'light'">{{
                                    appService.tema === 'dark' ? 'brightness_4' : 'brightness_7' }}</mat-icon>
                            </div>
                        </div>
                    </div>

                    <div class="footer">
                        <div class="">
                            <div class="perfil noselect" id="menu-tempo-entrega">
                                <div [matMenuTriggerFor]="perfil">{{nomeUsuario}} <mat-icon>expand_more</mat-icon></div>
                                <mat-menu #perfil="matMenu" xPosition="before">
                                    <button mat-menu-item (click)="abrirModalAlterarSenha()">Alterar Senha</button>
                                    <button mat-menu-item (click)="authService.logOff()">Sair</button>
                                </mat-menu>
                            </div>
                        </div>

                        <span (click)="this.appService.fecharBottomSheetConfiguracao()">Fechar</span>
                    </div>
                </div>
            </div>


        </ng-container>

        <ng-container *ngIf="this.appService.modoMobileEstaAtivado">
            <div class="option-mobile noselect">
                <mat-icon (click)="this.appService.toggleBottomSheetConfiguracao()">
                    more_vert
                </mat-icon>
            </div>
        </ng-container>

    </div>
</main>